import React, { useState } from "react"

import { useTranslation } from "react-i18next"

import {Modal} from "components/modals/Modal"

import { AdminPlayerBonus2 } from "services/bonus/type"

import { getDisplayName } from "../../helpers/bonus2.helpers"

interface Props {
  playerBonus: AdminPlayerBonus2
  onConfirm: (reason: string) => void
  onClose: () => void
}

export const CancelBonusModal = ({ playerBonus, onConfirm, onClose }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [reason, setReason] = useState("")

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason)
    }
  }

  return (
    <Modal open={true} handler={onClose}>
      <div className="bg-[#1A1A2E] rounded-lg p-6 w-full max-w-md space-y-4">
        <h3 className="text-lg font-bold text-white">{t("bonus2.players.cancelBonus")}</h3>

        <div className="bg-[#0C0C1A] rounded-lg p-3">
          <div className="text-gray-400 text-sm">{t("bonus2.players.bonus")}</div>
          <div className="text-white font-semibold">{getDisplayName(playerBonus.bonus?.name, t("bonus2.shared.unknownBonus") as string)}</div>
          <div className="text-gray-500 text-xs">{playerBonus.bonus?.type}</div>
        </div>

        <div className="bg-[#0C0C1A] rounded-lg p-3">
          <div className="text-gray-400 text-sm">{t("bonus2.players.status")}</div>
          <div className="text-yellow-400 font-semibold">{playerBonus.status}</div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">{t("bonus2.players.cancellationReason")}</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t("bonus2.players.enterReasonForCancelling")}
            rows={3}
            className="w-full bg-[#0C0C1A] text-white border border-gray-600 rounded px-3 py-2 resize-none"
          />
        </div>

        <div className="flex gap-3 pt-2">
          <button type="button" onClick={onClose} className="flex-1 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">
            {t("bonus2.players.close")}
          </button>
          <button
            onClick={handleConfirm}
            disabled={!reason.trim()}
            className="flex-1 px-4 py-2 bg-rose-600 text-white rounded hover:bg-rose-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t("bonus2.players.cancelBonus")}
          </button>
        </div>
      </div>
    </Modal>
  )
}
